import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#009688', // your main color here (e.g., blue)
    },
    secondary: {
        main: '#4db6ac'
    },
  },
});

export default theme;